import React, { Component } from "react";
import { Button, DatePicker, Select, message, Input } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import Fetch from "../../utils/fetch";
import "./index.css";

const { Option } = Select;
const { RangePicker } = DatePicker;

// Complaint categories for Ops (rest stop violation) tickets - TRAC-683.
const CATEGORY_OPTIONS = [
  "SHORT REST STOP",
  "EXCESSIVE WAIT AT REST STOP",
  "UNAUTHORIZED STOP"
];

// Ticket statuses.
const STATUS_OPTIONS = ["CREATED", "INPROGRESS", "CLOSED", "REJECTED"];

class opsTicketSearch extends Component {
  state = {
    fromDate: null,
    toDate: null,
    complaintCategory: null,
    status: null,
    busRc: "",
    hub: null,
    serviceHub: []
  };

  async componentDidMount() {
    const serviceHub = await this.fetchServiceHub();
    this.setState({ serviceHub });
  }

  // Service hubs come from the same endpoint the crew ticket filters use.
  fetchServiceHub = async () => {
    try {
      const response = await Fetch(`/bus-tracker/serviceHub`, {
        method: "get"
      });
      return response && Array.isArray(response) ? response : [];
    } catch (err) {
      message.error("unable to fetch hubs");
      return [];
    }
  };

  handleDateChange = dates => {
    this.setState({
      fromDate: dates ? dates[0].startOf("day") : null,
      toDate: dates ? dates[1].endOf("day") : null
    });
  };

  handleRcChange = event => {
    this.setState({ busRc: event.target.value });
  };

  showResult = () => {
    const {
      fromDate,
      toDate,
      complaintCategory,
      status,
      busRc,
      hub
    } = this.state;

    if ((fromDate && !toDate) || (toDate && !fromDate)) {
      message.error("please select both dates");
      return;
    }

    const body = {};
    if (fromDate && toDate) {
      body.fromDate = fromDate.valueOf();
      body.toDate = toDate.valueOf();
    }
    if (complaintCategory) {
      body.complaintCategory = complaintCategory;
    }
    if (status) {
      body.complainStatus = status;
    }
    if (busRc && busRc.trim()) {
      body.busRc = busRc.trim();
    }
    if (hub) {
      body.hub = hub;
    }

    this.props.showLoader();
    this.props.onSearch(body);
  };

  handleRefresh = () => {
    this.setState(
      {
        fromDate: null,
        toDate: null,
        complaintCategory: null,
        status: null,
        busRc: "",
        hub: null
      },
      () => {
        this.props.showLoader();
        this.props.onSearch({});
      }
    );
  };

  render() {
    const {
      fromDate,
      toDate,
      complaintCategory,
      status,
      busRc,
      hub,
      serviceHub
    } = this.state;

    return (
      <div className="opsSearchPanel">
        <div className="opsSearchRow">
          <div className="opsFilterGroup">
            <span className="opsFilterLabel">Date</span>
            <RangePicker
              style={{ width: 250 }}
              format="D MMM YYYY"
              value={fromDate && toDate ? [fromDate, toDate] : null}
              onChange={this.handleDateChange}
            />
          </div>

          <div className="opsFilterGroup">
            <span className="opsFilterLabel">Complaint Category</span>
            <Select
              style={{ width: 220 }}
              placeholder="Complaint Category"
              allowClear
              value={complaintCategory}
              onChange={value => this.setState({ complaintCategory: value })}
            >
              {CATEGORY_OPTIONS.map(category => (
                <Option value={category} key={category}>
                  {category}
                </Option>
              ))}
            </Select>
          </div>

          <div className="opsFilterGroup">
            <span className="opsFilterLabel">Status</span>
            <Select
              style={{ width: 160 }}
              placeholder="Status"
              allowClear
              value={status}
              onChange={value => this.setState({ status: value })}
            >
              {STATUS_OPTIONS.map(option => (
                <Option value={option} key={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </div>

          <div className="opsFilterGroup">
            <span className="opsFilterLabel">Hub</span>
            <Select
              style={{ width: 160 }}
              placeholder="All Hubs"
              allowClear
              value={hub}
              onChange={value => this.setState({ hub: value })}
            >
              {serviceHub && serviceHub.length > 0
                ? serviceHub.map(service => (
                    <Option value={service.name} key={service.name}>
                      {service.name}
                    </Option>
                  ))
                : null}
            </Select>
          </div>

          <div className="opsFilterGroup">
            <span className="opsFilterLabel">RC</span>
            <Input
              style={{ width: 200 }}
              placeholder="Search by bus RC"
              value={busRc}
              onChange={this.handleRcChange}
              onPressEnter={this.showResult}
              prefix={<SearchOutlined style={{ color: "#bbb" }} />}
              allowClear
            />
          </div>

          <div className="opsFilterGroup opsSearchBtn">
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={this.showResult}
            >
              Search
            </Button>
          </div>

          <div className="opsFilterGroup opsSearchBtn">
            <Button icon={<ReloadOutlined />} onClick={this.handleRefresh}>
              Refresh
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default opsTicketSearch;
